<template>
    <v-container fill-height class="align-start">
        <div class="row no-gutters" width="100%">
            <v-col>
                <v-toolbar class="elevation-0 mt-n3 row-full" height="relative">
                    <div class="container d-flex pb-3 pt-2 align-center">
                        <router-link to="/shopping/categories">
                        <v-icon class="go-back">mdi-arrow-left-bold</v-icon>
                        </router-link>
                        <v-toolbar-title color="primary" class="headline ml-5 font-weight-bold text-capitalize">{{ product.name }}</v-toolbar-title>
                    </div>
                    <template v-slot:extension>
                        <div class="container d-flex pb-7">
                            <div style="max-width:190px;" class="selection--teal">
                                <v-select
                                    flat
                                    @change="getRange"
                                    :items="product.prices"
                                    hide-details
                                    solo
                                    dense
                                    menu-props="offset-y"
                                    width="160px"
                                    background-color="#f8f8fd"
                                    color="grey darken-4"
                                    item-color="primary"
                                    prefix="Price"
                                    class="selection--teal"
                                    clearable
                                >
                                </v-select>
                            </div>
                            <div style="max-width:160px;" class="ml-1">
                                <v-select
                                    flat
                                    v-model="filters.brand"
                                    :items="product.brands"
                                    hide-details
                                    solo
                                    dense
                                    :menu-props="{'offset-y': true, 'max-width': 300, 'min-width': 300}"
                                    width="160px"
                                    background-color="#f8f8fd"
                                    color="grey darken-4"
                                    item-color="primary"
                                    item-text="brand"
                                    item-value="abbreviation"
                                    return-object
                                    :prefix="brandOrModel"
                                    class="selection--teal"
                                >
                                </v-select>
                            </div>
                            <div style="max-width:160px;" class="ml-1">
                                <v-select
                                    flat
                                    v-model="filters.year"
                                    :items="['2015', '2016', '2017', '2018', '2019', '2020']"
                                    return-object
                                    item-value="text"
                                    hide-details
                                    solo
                                    dense
                                    menu-props="offset-y"
                                    width="160px"
                                    background-color="#f8f8fd"
                                    color="grey darken-4"
                                    item-color="primary"
                                    prefix="Sort by Year"
                                    class="selection--teal"
                                >
                                </v-select>
                            </div>

                            <v-spacer></v-spacer>
                            <v-btn depressed class="align-self-center float-right noBtnCase ml-1 primary--text" color="#f8f8fd" @click="showFilters = !showFilters">
                                Filters
                                <v-icon>mdi-filter-outline</v-icon>
                            </v-btn>
                    </div>
                    </template>
                </v-toolbar>

                <loading-overlay :loading="loading"></loading-overlay>

                <v-row class="row-full mt-24" no-gutters>
                    <v-col>
                        <v-expand-transition>
                            <v-card
                                class="transition-fast-in-fast-out"
                                v-show="showFilters"
                                height="auto"
                                width="100%"
                                flat
                                tile
                            >
                                <v-row class="justify-center">
                                    <v-col style="max-width: 1185px;" class="mb-4" >
                                        <v-row>
                                            <v-col>
                                                <p class="subtitle blue-grey--text">Ratings</p>
                                                <v-row no-gutters class="align-center">
                                                    <v-col>
                                                        <v-checkbox
                                                            color="primary"
                                                            hide-details
                                                            dense
                                                            label="Any Rating"
                                                            @click="starRating = 0"
                                                        ></v-checkbox>
                                                    </v-col>
                                                    <v-col>
                                                    </v-col>
                                                </v-row>

                                                <template v-for="n in 5">
                                                    <v-row no-gutters class="align-center" :key="n">
                                                        <v-col>
                                                            <v-checkbox
                                                                color="primary"
                                                                hide-details
                                                                dense
                                                                @click="starRating = n"
                                                                :label="`${n} star${n>1 && 's'}`"
                                                            >
                                                            </v-checkbox>
                                                        </v-col>
                                                        <v-col class="filterStars">
                                                            <template v-for="i in 5">
                                                                <v-icon size="16" :key="i" :color="i > n ? 'grey lighten-1' : 'yellow darken-1'">
                                                                    {{ i > n ? 'mdi-star-outline' : 'mdi-star' }}
                                                                </v-icon>
                                                            </template>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-expand-transition>
                    </v-col>
                </v-row>

                <v-data-iterator
                    :items="product.data"
                    :items-per-page="pagination.ordersPerPage"
                    :page.sync="pagination.page"
                    hide-default-footer
                    :loading="loading"
                    @page-count="pagination.pageCount = $event"
                class="d-flex flex-column mh-100 overflow-hidden"
                >
                    <template v-slot:default="props">
                        <v-row class="fill-height" id="container">
                            <v-col
                                v-for="item in product.data"
                                :key="item.name"
                                :cols="4"
                                class="py-2"
                            >
                                <item :item="item" @view-item="viewItem" />
                            </v-col>
                        </v-row>
                    </template>

                    <template v-slot:footer>
                        <v-pagination
                            v-model="pagination.page"
                            :length="pagination.pageCount"
                            :total-visible="7"
                        />
                    </template>
                </v-data-iterator>

                <ViewItem :item="item" :visible="showView" @close="showView = false" />
            </v-col>
        </div>
    </v-container>
</template>

<script>
// const categories = require('../../modules/categories');
import item from './components/item';
import ViewItem from './components/view-item';

export default {
    components: { item, ViewItem },
    data: () => ({
        product: {
            data: [],
        },
        filters: {
            brand: '',
            year: '',
        },
        type: '',
        starRating: 0,
        showFilters: false,
        loading: true,
        pagination: {
            ordersPerPage: 5,
            page: 1,
            pageCount: 0,
        },
        item: {},
        showView: false,
        price: {
            min: 0,
            max: 10000000,
        },
    }),
    methods: {
        viewItem(item) {
            this.item = item;
            this.showView = true;
        },
        getRange(val) {
            if(val.includes('-')) {
                const price = val.replace(/\$/g, '').replace(/\$/g, '').split(' - ');
                this.price = {
                    min: Number(price[0]),
                    max: Number(price[1]),
                };
            } else {
                const dollarIndex = val.indexOf('$');
                const price = Number(val.slice(dollarIndex+1));

                this.price = {
                    min: val.includes('Below') ? 0 : price,
                    max: val.includes('Above') ? price : 10000000,
                };
            }
        }
    },
    computed: {
        brandOrModel() {
            const { category } = this.$route.params;
            return category.includes("television") ? "Model" : "Brand"
        },
        productData() {
            const { min, max } = this.price;
            const { filters, product } = this;
            return this.product.data.filter(key => (key.price >= min && key.price < max)
                            && key.brand.toLowerCase().includes(filters.brand.toLowerCase())
                            && key.year.includes(filters.year)
                    );
        }
    },
    mounted() {
        setTimeout(() => {
            this.loading = false;
            this.product = {
                ...this.categories[this.$route.params.category],
                name: String(this.$route.params.category).replace(/-/g, ' '),
                type: '',
            };
        }, 3000);
    }
}
</script>

<style>
.theme--light.v-divider {
    border-color: rgba(0,0,0,0.02);
}
.primary--outline {
    background-color: transparent;
    border: 2px solid #3F51B5;
}
.FillBG {
    background: #FAFAFA
}

.row-full{
    width: 100vw;
    position: relative;
    margin-left: -50vw;
    left: 50%;
}

.v-toolbar.row-full {
    width: 100vw;
    position: absolute;
    margin-left: -50vw;
    left: 50%;
}

.transition-enter-active, .transition-leave-active {
    transition: transform 1s;
}

.transition-enter .transition-leave-to {
    transform: scale(1, 0);;
}

.transition-enter-to, .transition-leave {
    transform: scale(1, 1);;
}

.filterStars {
    margin-top: 8px;
}

.v-input--selection-controls {
    margin-top: 8px;
    padding-top: unset;
}

.guarantee {
    background: white;
    color: #000;
    border: 1px solid #cfd8dc;
    border-radius: .4em;
    opacity: 1.00 !important;
    box-shadow: rgba(0, 0, 5, 0.2) 0px 9px 12px -6px,
                rgba(0, 0, 5, 0.14) 0px 19px 29px 2px,
                rgba(0, 0, 5, 0.12) 0px 7px 26px 6px !important;
}

.guarantee:after {
    content: '';
    position: absolute;
    left: 0;
    top: 30%;
    width: 0;
    height: 0;
    border: 9px solid transparent;
    border-right-color: white;
    border-left: 0;
    margin-top: -9px;
    margin-left: -9px;
}

.guarantee:before {
    content: '';
    position: absolute;
    left: 0;
    top: 30%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-right-color: #cfd8dc;
    border-left: 0;
    margin-top: -10px;
    margin-left: -10px;
}

.noBtnCase {
    text-transform: unset;
}

.row-full{
    width: 100vw;
    position: relative;
    margin-left: -50vw;
    left: 50%;
}

.mt-10 {
    margin-top: 10em !important;
}

.mt-24 {
    margin-top: 96px !important;
}

.selection--teal .v-select__selection.v-select__selection--comma {
    color: #4DB6AC;
}

.selection--teal >>> .v-text-field__prefix {
    margin-top: -2px !important;
}

.selection--teal >>> .v-select__slot {
    font-size: .876rem !important;
    font-weight: 500 !important;
    letter-spacing: 1.095px;
}

.theme--light.v-pagination .v-pagination__item {
    background: none !important;
    color: #4147d6;
}

.v-pagination__item {
    border: none;
    box-shadow: none !important;
    font-style: normal;
    font-size: 14px;
    line-height: 136.5%;
    text-decoration: none;
}

.theme--light.v-pagination .v-pagination__item--active {
    font-weight: 800;
}


.go-back {
    position: absolute;
    left: 5px;
}
</style>
